// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2WKjH","paramInput":"JobSimulator_paramInput__3ujE_","input":"JobSimulator_input__BDFpV"};